import { camelCase } from '@ridi/object-case-converter';
import { extendObservable } from 'mobx';
import AbstractRoot from '../../common_components/stores/AbstractRoot';
import AttachmentsStore from '../../common_components/attachments/stores/Attachments';
import GooglePicker from '../../../libs/google_picker';
import BoxPicker from '../../../libs/box_picker';
import FeedbackChainsStore from './FeedbackChains';

export default class Root extends AbstractRoot {
  constructor(currentUser, localeStore, belongsToMainStartup, team) {
    super(camelCase(currentUser, true), [], localeStore);
    this.team = camelCase(team, true);

    this.attachmentsStore = new AttachmentsStore(this);
    this.feedbackChainsStore = new FeedbackChainsStore(this);
    this.currentUserBelongsToMainStartup = belongsToMainStartup;

    this.googlePicker = new GooglePicker();
    this.boxPicker = new BoxPicker();
  }
}
